export default "__VITE_ASSET__DkDbmlXc__"